import { writable } from 'svelte/store';

export const categoryStaticBottomContent = writable({ heading: '', body: '' });
export const categoryStaticTopContent = writable({ heading: '', body: '' });
export const compareProducts = writable([]);
export const isCategoryStaticBottomContent = writable(false);
export const isCategoryStaticTopContent = writable(false);
export const islocationDisabled = writable(false);
export const unxSortOptions = writable([]);
export const openRestockablePopup = writable(false);
export const restockableProductContent = writable(null);

function createSelectedRatingsStore() {
  const { set, update, subscribe } = writable<number[]>(null);

  return {
    subscribe,
    setBulkSelection: (selectedRatingsArray: number[]) => {
      set(selectedRatingsArray.sort());
    },
    setSingleRatingStatus: (starRating, selected: boolean) => {
      update(values => {
        if (selected) {
          return Array.from(new Set([...(values || []), starRating])).sort();
        }
        return (values || []).filter(x => x !== starRating);
      });
    },
  };
}

export const unxSelectedRatings = createSelectedRatingsStore();
